import manifest from './docs-manifest.json'

export interface NavItem {
  id: string
  label: string
  path: string
  children?: NavItem[]
}

export const navigation: NavItem[] = manifest.groups.map(group => ({
  id: group.id,
  label: group.label,
  path: `/docs/${group.id}`,
  children: group.items.map(item => ({
    id: item.id,
    label: item.label,
    path: `/docs/${group.id}/${item.id}`
  }))
}))

